// extracted by mini-css-extract-plugin
module.exports = {"historyWrapper":"HistoryWrapper_historyWrapper__3SxOn","historyHeader":"HistoryWrapper_historyHeader__1ok8R","deleteButton":"HistoryWrapper_deleteButton__3SiBS"};